// Module
var code = "<template>\n  <div class=\"dynamic-table__table-cell dynamic-table__table-cell__body\" title.bind=\"title\">\n    <slot></slot>\n  </div>\n</template>\n";
// Exports
export default code;